export default __webpack_public_path__ + "static/media/game_icon3.70718563.png";